<template>
    <div class="container pt-2">
        <PageTitle main="Transporte" sub="Cadastrar, alterar ou deletar Transporte" />
        <b-form>
            <input id="transporte-id" type="hidden" v-model="transporte.id" />
            <div class="row">
                <div class="col-md-4">
                    <b-form-group label="Origem:" label-for="transporte-origem">
                        <b-input-group>
                            <b-form-select id="transporte-origem" :options="origems" v-model="transporte.origem" 
                            @change="showAlert"
                            :class="{ 'inputError': $v.transporte.origem.$error }"
                            class="textInput"
                            @keydown.tab="$v.transporte.origem.$touch"/>
                            <b-input-group-append>
                                <b-button class="botaoInput" variant="outline-success" to="clientes"><i class="far fa-plus-square"></i></b-button>
                            </b-input-group-append>
                        </b-input-group>                        
                        <span class="error" v-if="!$v.transporte.origem.required && $v.transporte.origem.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-4" v-if="!atualizaDestino">
                    <b-form-group label="Destino:" label-for="transporte-destino">
                        <b-input-group>
                            <b-form-select id="transporte-destino" :options="destinos" v-model="transporte.destino" 
                            :class="{ 'inputError': $v.transporte.destino.$error }"
                            class="textInput"
                            @keydown.tab="$v.transporte.destino.$touch"/>
                            <b-input-group-append>
                                <b-button class="botaoInput" variant="outline-success" to="clientes"><i class="far fa-plus-square"></i></b-button>
                            </b-input-group-append>
                        </b-input-group>
                        <span class="error" v-if="!$v.transporte.destino.required && $v.transporte.destino.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group label="Motorista:" label-for="transporte-motorista">
                        <b-input-group>
                            <b-form-select id="transporte-motorista" :options="motoristas" 
                            v-model="transporte.motorista" @change="updateDate" 
                            :class="{ 'inputError': $v.transporte.motorista.$error }" 
                            class="textInput"
                            @keydown.tab="$v.transporte.motorista.$touch" 
                            />
                            <b-input-group-append>
                                <b-button class="botaoInput" variant="outline-success" to="funcionarios"><i class="far fa-plus-square"></i></b-button>
                            </b-input-group-append>
                        </b-input-group>
                        <span class="error" v-if="!$v.transporte.motorista.required && $v.transporte.motorista.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
            </div>
            <div class="row" v-if="transporte.motorista"> 
                <div class="col-md-4">
                    <b-form-group label="Data de Postagem:" label-for="transporte-data_inicio">
                        <Datepicker 
                        :language="ptBR" 
                        :disabledDates="dtp.disabledItens" 
                        :highlighted="dtp.highlighted" 
                        :bootstrap-styling="true"
                        v-model="transporte.data_inicio" 
                        id="transporte-data_inicio"
                        :class="{ 'inputError': $v.transporte.data_inicio.$error }"
                        @keydown.tab="$v.transporte.data_inicio.$touch">
                        </Datepicker>
                        <span class="error" v-if="!$v.transporte.data_inicio.required && $v.transporte.data_inicio.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group label="Previsão de Chegada:" label-for="transporte-data_final">
                        <Datepicker 
                        :language="ptBR" 
                        :disabledDates="dtp.disabledItens" 
                        :highlighted="dtp.highlighted" 
                        :bootstrap-styling="true"
                        v-model="transporte.data_final"
                        id="transporte-data_final"
                        :class="{ 'inputError': $v.transporte.data_final.$error }"
                        @keydown.tab="$v.transporte.data_final.$touch">
                        </Datepicker>
                        <span class="error" v-if="!$v.transporte.data_final.required && $v.transporte.data_final.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
            </div>
            <div class="row" v-if="transporte.motorista">
                <div class="col-md-3">
                    <b-form-group label="Carga:" label-for="transporte-carga">
                        <b-form-select id="transporte-carga" :options="cargas" v-model="carga" 
                        class="textInput"/>
                    </b-form-group>
                </div>
                <div class="col-md-3" v-if="carga==='container'">
                    <b-form-group label="Container Número:" label-for="transporte-container">
                        <b-form-input id="transporte-container" v-model="transporte.container" type="text"
                        :class="{ 'inputError': $v.transporte.container.$error }"
                        class="textInput"
                        @keydown.tab="$v.transporte.container.$touch"/>
                        <span class="error" v-if="!$v.transporte.container.required && $v.transporte.container.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.transporte.container.minLength && $v.transporte.container.$error">Precisa ter no mínimo 3 caracteres!</span>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group label="Tipo:" label-for="transporte-tipo">
                        <b-form-select id="transporte-tipo" :options="tipos" v-model="transporte.tipo"
                        :class="{ 'inputError': $v.transporte.tipo.$error }"
                        class="textInput"
                        @keydown.tab="$v.transporte.tipo.$touch"/>
                        <span class="error" v-if="!$v.transporte.tipo.required && $v.transporte.tipo.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-3" v-if="transporte.tipo==='importacao'">
                    <b-form-group label="Declaração de Importação (D.I.):" label-for="transporte-booking">
                        <b-form-input id="transporte-booking" v-model="transporte.booking"
                        :class="{ 'inputError': $v.transporte.booking.$error }"
                        class="textInput"
                        @keydown.tab="$v.transporte.booking.$touch"/>
                        <span class="error" v-if="!$v.transporte.booking.required && $v.transporte.booking.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.transporte.booking.minLength && $v.transporte.booking.$error">Precisa ter no mínimo 3 caracteres!</span>
                    </b-form-group>
                </div>
                <div class="col-md-3" v-if="transporte.tipo==='exportacao'">
                    <b-form-group label="Booking:" label-for="transporte-booking">
                        <b-form-input id="transporte-booking" v-model="transporte.booking"
                        :class="{ 'inputError': $v.transporte.booking.$error }"
                        class="textInput"
                        @keydown.tab="$v.transporte.booking.$touch"/>
                        <span class="error" v-if="!$v.transporte.booking.required && $v.transporte.booking.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.transporte.booking.minLength && $v.transporte.booking.$error">Precisa ter no mínimo 3 caracteres!</span>                        
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12" v-if="carga==='cs'">
                    <b-form-group label="Descrição:" label-for="transporte-descricao">
                        <b-form-textarea id="transporte-descricao" v-model="transporte.descricao" rows="3"
                        :class="{ 'inputError': $v.transporte.descricao.$error }"
                        class="textInput"
                        @keydown.tab="$v.transporte.descricao.$touch">
                        </b-form-textarea>
                        <span class="error" v-if="!$v.transporte.descricao.required && $v.transporte.descricao.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.transporte.descricao.minLength && $v.transporte.descricao.$error">Precisa ter no mínimo 3 caracteres!</span>
                    </b-form-group>
                </div>
            </div>
            <b-button variant="outline-success" class="mt-3 botaoInput" @click="save">Salvar</b-button>
            <b-button variant="outline-danger" class="ml-2 mt-3 botaoInput" @click="reset">Cancelar</b-button>
        </b-form>
        <hr>
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        class="textInput"
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" class="botaoInput" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-transportes" 
                class="text-center table table-sm" 
                :items="transportes.length>0?transportes:[]" 
                :fields="fields" 
                per-page="5"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="remove(data.item)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
                <template v-slot:cell(rastreio_key)="data">
                    <router-link :to="{ name: 'rastreio', params: { id: data.item.rastreio } }">{{ data.item.rastreio }}</router-link>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="5"
                aria-controls="table-transportes"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        class="textInput"
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" class="botaoInput" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-transportes" 
                class="text-center table table-sm" 
                :items="transportes.length>0?transportes:[]" 
                :fields="fields" 
                per-page="5"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="remove(data.item)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
                <template v-slot:cell(rastreio_key)="data">
                    <router-link :to="{ name: 'rastreio', params: { id: data.item.rastreio } }">{{ data.item.rastreio }}</router-link>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="5"
                aria-controls="table-transportes"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>



    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import { ptBR } from 'vuejs-datepicker/dist/locale'
import { required, minLength } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'transportes',
    components: { PageTitle, Datepicker },
    data: function() {
        return {
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            jwt: new VueEasyJwt(),
            level: '',
            quemRecebeu: '',
            nome: '',
            email: '',
            razao: '',
            codRastreio: '',
            ptBR: ptBR,
            transporte: {},
            transportes: [],
            origem: {},
            origems: [],
            destino: {},
            destinos: [],
            motorista: {},
            motoristas: [],
            atualizaDestino: false,
            auxMotorista: '',
            fields: [
                { key: 'origem', label: 'Origem', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'destino', label: 'Destino', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'motorista', label: 'Motorista', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'rastreio_key', label: 'Rastreio', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'actions', label: 'Ações', thClass: 'tituloTabela', tdClass: 'actionsTabela' }
            ],
            tipos: [
                { value: 'importacao', text: 'Importação' },
                { value: 'exportacao', text: 'Exportação' }
            ],
            cargas: [
                { value: 'container', text: 'Container' },
                { value: 'cs', text: 'Carga Solta' }
            ],
            carga: 'container',
            dtp: {
                disabledItens: {
                    dates: [],
                },
                highlighted: {
                    dates: [],
                },
                includeDisabled: true
            },
            dataMotoristas: [],
            temp: {},
            larguraTela: 0,
            overflowValue: 'auto'
        }
    },
    computed: {
        ...mapState(['user']),
        rows() {
            return this.transportes.length
        }
    },
    validations() {
        if (this.carga === 'container') {
            return {
                transporte: {
                    origem: {
                        required
                    },
                    destino: {
                        required
                    },
                    motorista: {
                        required
                    },
                    data_inicio: {
                        required
                    },
                    data_final: {
                        required
                    },
                    container: {
                        required,
                        minLength: minLength(3)
                    },
                    tipo: {
                        required
                    },
                    booking: {
                        required,
                        minLength: minLength(3)
                    }
                }
            }
        } else {
            return {
                transporte: {
                    origem: {
                        required
                    },
                    destino: {
                        required
                    },
                    motorista: {
                        required
                    },
                    data_inicio: {
                        required
                    },
                    data_final: {
                        required
                    },
                    descricao: {
                        required,
                        minLength: minLength(3)
                    },
                    tipo: {
                        required
                    },
                    booking: {
                        required,
                        minLength: minLength(3)
                    }
                }
            }
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        updateDate() {
            this.highlightDTP()
            this.disableDTP()
        },
        highlightDTP(){
            const motorista = this.transporte.motorista
            const url = `${baseApiUrl}/backend/highlightMotorista.php?motorista=${motorista}`
            axios.get(url).then(res => {
                if(res.data['dados']!=='false'){
                    this.dtp.highlighted.dates = res.data.map(dataMotorista => {
                        const data = new Date(dataMotorista.data)
                        data.setDate(data.getDate() + 1)
                        return  data
                    })
                }
            })
        },
        disableDTP(){
            const motorista = this.transporte.motorista
            const url = `${baseApiUrl}/backend/disabledMotorista.php?motorista=${motorista}`
            axios.get(url).then(res => {
                if(res.data['dados']!=='false'){
                    this.dtp.disabledItens.dates = res.data.map(dataMotorista => {
                        const data = new Date(dataMotorista.data)
                        data.setDate(data.getDate() + 1)
                        return data
                    })
                }
            })
        },
        showAlert() {
            this.loadDestinos()
            this.atualizaDestino = true
            const itemOrigem = document.getElementById("transporte-origem").value
            const itemDestino = document.getElementById("transporte-destino")
            for (let i = 0; i < this.destinos.length; i++) {
                if (itemDestino.options[i].value === itemOrigem) {
                    document.getElementById("transporte-destino").options[i].style.display = 'none'
                } else {
                    document.getElementById("transporte-destino").options[i].style.display = 'block'
                }
            }
            this.atualizaDestino = false
        },
        loadOrigems() {
            const url = `${baseApiUrl}/backend/clientes.php`
            axios.get(url).then(res => {
                if(res.data['dados']!=='Não há dados disponíveis'){
                    this.origems = res.data.map(origem => {
                        return { ...origem, value: origem.nome, text: origem.nome }
                    })
                }else{
                    this.origems.push({ value: 'null', text: 'Não há dados disponíveis' })
                }
            })
        },
        loadDestinos() {
            const url = `${baseApiUrl}/backend/clientes.php`
            axios.get(url).then(res => {
                if(res.data['dados']!=='Não há dados disponíveis'){
                    this.destinos = res.data.map(destino => {
                        return { ...destino, value: destino.nome, text: destino.nome }
                    })
                }else{
                    this.destinos.push({ value: 'null', text: 'Não há dados disponíveis' })
                }
            })
        },
        loadMotoristas() {
            const url = `${baseApiUrl}/backend/motoristas.php`
            axios.get(url).then(res => {
                if(res.data['dados']!=='Não há dados disponíveis'){
                    this.motoristas = res.data.map(motorista => {
                        return { ...motorista, value: motorista.nome, text: motorista.nome }
                    })
                }else{
                    this.motoristas.push({ value: 'null', text: 'Não há dados disponíveis' })
                }
            })
        },
        loadTransportes() {
            const url = `${baseApiUrl}/backend/transportes.php`
            axios.get(url).then(res => {
                this.transportes = res.data
                if(this.transportes.length > 0){
                    this.exibeRodape = false
                }else{
                    this.exibeRodape = true
                }
            })
        },
        reset() {
            this.transporte = {}
            this.loadTransportes()
            this.carga = 'container'
            this.transporte.tipo = 'importacao'
            this.auxMotorista = ''
            this.$v.transporte.$reset()
        },
        save() {
            this.$v.transporte.$touch()
            if(!this.$v.transporte.$error){
                if(this.carga === 'container'){
                    this.transporte.descricao = ''
                }
                if(this.carga === 'cs'){
                    this.transporte.container = ''
                }

                this.transporte.responsavel = this.quemRecebeu

                axios['post'](`${baseApiUrl}/backend/transportes.php`, this.transporte)
                    .then((res) => {
                        this.temp.rastreio = res.data['rastreio']
                        this.temp.orId = res.data['origemId']
                        this.temp.orNome = res.data['origemNome']
                        this.temp.orEmail = res.data['origemEmail']
                        this.temp.orEnd = res.data['origemEnd']
                        this.temp.destId = res.data['destinoId']
                        this.temp.destNome = res.data['destinoNome']
                        this.temp.destEmail = res.data['destinoEmail']
                        this.temp.destEnd = res.data['destinoEnd']
                        this.temp.motorista = res.data['motorista']
                        this.temp.motoristaEmail = res.data['motoristaEmail']
                        this.temp.inicio = res.data['inicio']
                        this.temp.final = res.data['final']
                        
                        // DESTINO (CLIENTE)
                        const tipo1 = `?tipo=novoTransporteCliente`
                        const destinoEmail1 = `&destinoEmail=${this.temp.destEmail}`
                        const destinoNome1 = `&destinoNome=${this.temp.destNome}`
                        const rastreio1 = `&rastreio=${this.temp.rastreio}`
                        const razao1 = `&razao=${this.razao}`
                        axios.get(`${baseApiUrl}/backend/mailCliente.php
                            ${tipo1}${destinoEmail1}${destinoNome1}${rastreio1}${razao1}`).then(() => {})

                        // ORIGEM (CLIENTE)
                        const tipo2 = `?tipo=novoTransporteCliente`
                        const destinoEmail2 = `&destinoEmail=${this.temp.orEmail}`
                        const destinoNome2 = `&destinoNome=${this.temp.orNome}`
                        const rastreio2 = `&rastreio=${this.temp.rastreio}`
                        const razao2 = `&razao=${this.razao}`
                        axios.get(`${baseApiUrl}/backend/mailCliente.php
                            ${tipo2}${destinoEmail2}${destinoNome2}${rastreio2}${razao2}`).then(() => {})

                        // FUNCIONARIO (FUNCIONARIO)
                        const tipo3 = `?tipo=novoTransporteFuncionario`
                        const destinoEmail3 = `&destinoEmail=${this.email}`
                        const destinoNome3 = `&destinoNome=${this.nome}`
                        const origemNome3 = `&origemNome=${this.temp.orNome}`
                        const origemEnd3 = `&origemEnd=${this.temp.orEnd}`
                        const destNome3 = `&destNome=${this.temp.destNome}`
                        const destEnd3 = `&destEnd=${this.temp.destEnd}`
                        const motorista3 = `&motorista=${this.temp.motorista}`
                        const inicio3 = `&inicio=${this.temp.inicio}`
                        const final3 = `&final=${this.temp.final}`
                        const rastreio3 = `&rastreio=${this.temp.rastreio}`
                        axios.get(`${baseApiUrl}/backend/mailFuncionario.php
                            ${tipo3}${destinoEmail3}${destinoNome3}${rastreio3}
                            ${origemNome3}${origemEnd3}${destNome3}${destEnd3}
                            ${motorista3}${inicio3}${final3}`).then(() => {})

                        // MOTORISTA (MOTORISTA)
                        const tipo4 = `?tipo=novoTransporteMotorista`
                        const destinoEmail4 = `&destinoEmail=${this.temp.motoristaEmail}`
                        const destinoNome4 = `&destinoNome=${this.temp.motorista}`
                        const rastreio4 = `&rastreio=${this.temp.rastreio}`
                        const razao4 = `&razao=${this.razao}`
                        axios.get(`${baseApiUrl}/backend/mailMotorista.php
                            ${tipo4}${destinoEmail4}${destinoNome4}${rastreio4}${razao4}`).then(() => {})
                        
                        this.$toasted.global.defaultSuccess({ message : 'Transporte inserido com sucesso!' })
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    })
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        remove(transporte) {
            const sure = confirm("Deseja realmente excluir o transporte? Irá excluir toda a evolução do transporte!")
            if(sure === true){
                const url = `${baseApiUrl}/backend/transportes.php`
                axios.delete(url, { data: transporte })
                    .then(() => {

                        // DESTINO (CLIENTE)
                        const tipo1 = `?tipo=deletaTransporteCliente`
                        const destinoEmail1 = `&destinoEmail=${this.temp.destEmail}`
                        const destinoNome1 = `&destinoNome=${this.temp.destNome}`
                        const rastreio1 = `&rastreio=${this.temp.rastreio}`
                        axios.get(`${baseApiUrl}/backend/mailCliente.php
                            ${tipo1}${destinoEmail1}${destinoNome1}${rastreio1}`).then(() => {})

                        // ORIGEM (CLIENTE)
                        const tipo2 = `?tipo=deletaTransporteCliente`
                        const destinoEmail2 = `&destinoEmail=${this.temp.orEmail}`
                        const destinoNome2 = `&destinoNome=${this.temp.orNome}`
                        const rastreio2 = `&rastreio=${this.temp.rastreio}`
                        axios.get(`${baseApiUrl}/backend/mailCliente.php
                            ${tipo2}${destinoEmail2}${destinoNome2}${rastreio2}`).then(() => {})

                        // FUNCIONARIO (FUNCIONARIO)
                        const tipo3 = `?tipo=deletaTransporteFuncionario`
                        const destinoEmail3 = `&destinoEmail=${this.email}`
                        const destinoNome3 = `&destinoNome=${this.nome}`
                        const rastreio3 = `&rastreio=${this.temp.rastreio}`
                        axios.get(`${baseApiUrl}/backend/mailFuncionario.php
                            ${tipo3}${destinoEmail3}${destinoNome3}${rastreio3}`).then(() => {})

                        // MOTORISTA (MOTORISTA)
                        const tipo4 = `?tipo=deletaTransporteMotorista`
                        const destinoEmail4 = `&destinoEmail=${this.temp.motoristaEmail}`
                        const destinoNome4 = `&destinoNome=${this.temp.motorista}`
                        const rastreio4 = `&rastreio=${this.temp.rastreio}`
                        axios.get(`${baseApiUrl}/backend/mailMotorista.php
                            ${tipo4}${destinoEmail4}${destinoNome4}${rastreio4}`).then(() => {})

                        this.$toasted.global.defaultSuccess({ message : 'Transporte excluído com sucesso!' })
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.quemRecebeu = decodedToken['data'].id
                this.nome = decodedToken['data'].nome
                this.email = decodedToken['data'].email
                this.razao = decodedToken['data'].razao
            }
        }
    },
    mounted() {
        this.validaLogin()
        if (this.level === 'cliente') {
            this.$router.push('/')
        } else if (this.level === 'motorista') {
            this.$router.push('/')
        }
        this.loadTransportes()
        this.loadOrigems()
        this.loadDestinos()
        this.loadMotoristas()
        this.carga = 'container'
        this.transporte.tipo = 'importacao'
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.transportes.length
    }
}
</script>

<style>
.table {
    font-size: 0.9rem;
}

.textInput, #transporte-data_final, #transporte-data_inicio {
    border: 1px solid rgb(220, 220, 220);
    outline: 0 !important;
    border-radius: 0px !important;
    background-color: transparent !important;
    font-size: 0.8rem !important;
}

.botaoInput {
    font-size: 0.8rem !important;
    border-radius: 0px !important;
}

.cell.disabled {
    background-color: rgb(253, 131, 131) !important;
    color: white !important;
}

.cell.highlighted {
    background-color: rgb(255, 241, 118) !important;
    color: rgb(0, 0, 0) !important;
}

.error {
    color: #f57f6c;
    font-size: 0.6rem;
    padding-left: 10px;
}

.inputError {
    color: #f57f6c;
    border-bottom: 1px solid #f57f6c !important;
}

.btn-size {
    width: 30px;
    height: 30px;
}

a {
    text-decoration: none !important;
    color: black;
}

a:hover {
    color: grey;
}

.text-custom {
    font-size: 0.8rem;
}
</style>